'use strict'

$(function () {

  let images = [...document.querySelectorAll('.lazy-image')]
  const interactSettings = {
    root: document.querySelector('.center'),
    rootMargin: '0px 0px 200px 0px',
  }

  function onIntersection (imageEntites) {
    imageEntites.forEach(image => {
      if (image.isIntersecting) {
        observer.unobserve(image.target)
        image.target.src = image.target.dataset.src
        image.target.onload = () => image.target.classList.add('loaded')
      }
    })
  }

  let observer = new IntersectionObserver(onIntersection, interactSettings)
  images.forEach(image => observer.observe(image))

  var _lang = document.documentElement.lang
  // ------------------------------------------------------- //
  //   Lightbox in galleries
  // ------------------------------------------------------ //

  $('.slider-gallery').each(function () { // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true,
        tCounter: '', // markup of counter
      },
    })
  })

  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,

    fixedContentPos: false,
  })

  $('.gallery').each(function () { // the containers for all your galleries
    $(this).magnificPopup({
      delegate: 'a', // the selector for gallery item
      type: 'image',
      gallery: {
        enabled: true,
      },
    })
  })

  // =====================================================
  //     Reset input
  // =====================================================

  $('.input-reset .form-control').on('focus', function () {
    $(this).parents('.input-reset').addClass('focus')
  })
  $('.input-reset .form-control').on('blur', function () {
    setTimeout(function () {
      $('.input-reset .form-control').
        parents('.input-reset').
        removeClass('focus')
    }, 333)

  })

  // =====================================================
  //      Detail slider
  // =====================================================

  var detailSlider = new Swiper('.detail-slider', {
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      991: {
        slidesPerView: 4,
      },
      565: {
        slidesPerView: 3,
      },
    },

    // Enable lazy loading
    lazy: {
      //  tell swiper to load images before they appear
      loadPrevNext: true,
      // amount of images to load
      loadPrevNextAmount: 2,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  // =====================================================
  //      Items slider
  // =====================================================

  var similarSwiper = new Swiper('.similar-swiper', {
    slidesPerView: 4,
    spaceBetween: 5,
    loop: true,
    roundLengths: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
      565: {
        slidesPerView: 1,
      },
    },

    // Enable lazy loading
    lazy: {
      //  tell swiper to load images before they appear
      loadPrevNext: true,
      // amount of images to load
      loadPrevNextAmount: 2,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
  })

  var propertySimilarSwiper = new Swiper('.property-similar-swiper', {
    slidesPerView: 3,
    spaceBetween: 4,
    loop: true,
    roundLengths: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1,
      },
    },

    // Enable lazy loading
    lazy: {
      //  tell swiper to load images before they appear
      loadPrevNext: true,
      // amount of images to load
      loadPrevNextAmount: 2,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
  })

  var itemsSliderFull = new Swiper('.items-slider-full', {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    roundLengths: true,
    breakpoints: {
      1700: {
        slidesPerView: 4,
      },
      1400: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
      1070: {
        slidesPerView: 2,
      },
      670: {
        slidesPerView: 1,
      },
    },

    // Enable lazy loading
    lazy: {
      //  tell swiper to load images before they appear
      loadPrevNext: true,
      // amount of images to load
      loadPrevNextAmount: 2,
    },

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
  })

  var brandsSlider = new Swiper('.brands-slider', {
    slidesPerView: 5,
    spaceBetween: 15,
    loop: true,
    roundLengths: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
    },
    // Enable lazy loading
    lazy: {
      //  tell swiper to load images before they appear
      loadPrevNext: true,
      // amount of images to load
      loadPrevNextAmount: 2,
    },
  })

  // ------------------------------------------------------- //
  //   Increase/Decrease product amount
  // ------------------------------------------------------ //

  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= 1500) {
      $('#scrollTop').fadeIn()
    }
    else {
      $('#scrollTop').fadeOut()
    }
  })

  $('#scrollTop').on('click', function () {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000)
  })

  // ------------------------------------------------------- //
  // Adding fade effect to dropdowns
  // ------------------------------------------------------ //

  $.fn.slideDropdownUp = function () {
    $(this).fadeIn().css('transform', 'translateY(0)')
    return this
  }
  $.fn.slideDropdownDown = function (movementAnimation) {

    if (movementAnimation) {
      $(this).fadeOut().css('transform', 'translateY(30px)')
    }
    else {
      $(this).hide().css('transform', 'translateY(30px)')
    }
    return this
  }

  $('.navbar .dropdown').on('show.bs.dropdown', function (e) {
    $(this).find('.dropdown-menu').first().slideDropdownUp()
  })
  $('.navbar .dropdown').on('hide.bs.dropdown', function (e) {

    var movementAnimation = true

    // if on mobile or navigation to another page
    if ($(window).width() < 992 ||
      (e.clickEvent && e.clickEvent.target.tagName.toLowerCase() === 'a')) {
      movementAnimation = false
    }

    $(this).find('.dropdown-menu').first().slideDropdownDown(movementAnimation)
  })

  // ------------------------------------------------------- //
  //    Collapse button control (used for more/less filters)
  // ------------------------------------------------------ //

  $('.btn-collapse').each(function () {
    var button = $(this),
      collapseId = button.attr('data-target')

    if ($(collapseId).length) {

      var collapseElement = $(collapseId)

      $(collapseElement).on('hide.bs.collapse', function () {
        button.text(button.attr('data-collapsed-text'))
      })

      $(collapseElement).on('show.bs.collapse', function () {
        button.text(button.attr('data-expanded-text'))
      })

    }
  })

  // ------------------------------------------------------- //
  //   Bootstrap tooltips
  // ------------------------------------------------------- //

  $('[data-toggle="tooltip"]').tooltip()

  // ------------------------------------------------------- //
  //   Smooth Scroll
  // ------------------------------------------------------- //

  // var smoothScroll = new SmoothScroll('a[data-smooth-scroll]', {
  //     offset: 80
  // });

  // ------------------------------------------------------- //
  //   Object Fit Images
  // ------------------------------------------------------- //

  // objectFitImages();

  // ------------------------------------------------------- //
  //   Change Currency
  // ------------------------------------------------------- //
  $('.change-currency').on('click', function (e) {
    e.preventDefault()
    var _currency = $(this).data('name')
    changeCurrency(_currency)
  })

  // Send Ajax Request To Change Currency
  function changeCurrency (_currency) {
    var _url = '/ajax/change-currency'
    var _data = {
      currency: _currency,
    }
    jQuery.ajax({
      url: _url,
      method: 'GET',
      data: _data,
      success: function (data) {
        if (data !== false) {
          location.reload()
        }
      },
    })
  }

  // ------------------------------------------------------- //
  //   phoneInput Form
  // ------------------------------------------------------- //

  $('.phoneInput').intlTelInput({
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js',
    nationalMode: true,
    separateDialCode: true,
    initialCountry: 'TR',
    geoIpLookup: function (success) {
      $.get('https://ipinfo.io', function () { }, 'jsonp').
        always(function (resp) {
          var countryCode = (resp && resp.country) ? resp.country : ''
          success(countryCode)
        })
    },
    preferredCountries: [
      'SA',
      'QA',
      'TR',
      'IQ',
      'KW',
      'BH',
      'AE',
      'YE',
      'JO',
      'DZ',
      'TN',
      'LY',
      'EG',
      'SD',
      'OM',
      'SY'],
  })

  if ($('.phoneInput').length) {
    $('.phoneInput').keydown(function (event) {
      // Allow: backspace, delete, tab, escape, and enter
      if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 ||
        event.keyCode == 27 || event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
        // let it happen, don't do anything
        return
      }
      else {
        // Ensure that it is a number and stop the keypress
        if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) &&
          (event.keyCode < 96 || event.keyCode > 105)) {
          event.preventDefault()
        }
      }
    })
  }

  // ------------------------------------------------------- //
  //   fixed button
  // ------------------------------------------------------- //

  if ($('.tg-chat-main-btn').length) {

    $(document).on('click', '.tg-chat-main-btn', function () {
      $('.tg-chat-notification').addClass('hide')
      $(this).addClass('hide')

      setTimeout(function () {
        $('.tg-chat-buttons-wrapper').addClass('active')
      }, 300)
    })

    $(document).on('click', '.tg-chat-btn.cancel', function () {

      $('.tg-chat-buttons-wrapper').removeClass('active')

      setTimeout(function () {
        $('.tg-chat-main-btn').removeClass('hide')
      }, 300)
    })

    $(document).on('click', '.tg-chat-btn.form', function () {

      $('.tg-chat-buttons-wrapper').removeClass('active')

      setTimeout(function () {
        $('.tg-chat-main-btn').removeClass('hide')
        $('#popupForm').modal('show')
      }, 300)

    })

    // Hide menu When Click Outside
    $(document).on('click', function (event) {
      var $trigger = $('.fixed-button')
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $('.tg-chat-buttons-wrapper').removeClass('active')

        setTimeout(function () {
          $('.tg-chat-main-btn').removeClass('hide')
        }, 300)
      }
    })
  }

  $('.search-property-btn').on('click', function (e) {
    var type = $(this).data('type')
    var _form_id = null
    switch (type) {
      case 'for-sale':
        _form_id = 'projects-for-sale-form'
        break
      case 'for-rent':
        _form_id = 'properties-for-rent-form'
        break
      case 'for-resale':
        _form_id = 'properties-for-resale-form'
        break
    }
    $('#' + _form_id).submit()
  })

  $('.search-property').on('submit', function (e) {
    e.preventDefault()
    var category = null
    var max_price = null
    var categories = null
    var features = null
    var towns = null
    var town = null
    var _data = {}

    var _form_id = $(this).attr('id')
    switch (_form_id) {
      case 'projects-for-sale-form':
        town = $(this).find('select[name=town]').val()
        categories = $(this).find('select[name=categories]').val()
        features = $(this).find('select[name=features]').val()
        _data = {
          'lang': _lang,
          'type': 'for-sale',
          'category': categories,
          'town': town,
          'features': features,
        }
        break
      case 'properties-for-rent-form':
        towns = $(this).find('select[name=towns]').val()
        category = $(this).find('select[name=category]').val()
        max_price = $(this).find('select[name=max_price]').val()
        _data = {
          'lang': _lang,
          'type': 'for-rent',
          'towns': towns,
          'category': category,
          'max_price': max_price,
        }
        break
      case 'properties-for-resale-form':
        towns = $(this).find('select[name=towns]').val()
        category = $(this).find('select[name=category]').val()
        max_price = $(this).find('select[name=max_price]').val()
        _data = {
          'lang': _lang,
          'type': 'for-resale',
          'towns': towns,
          'category': category,
          'max_price': max_price,
        }
        break
    }
    $.ajax({
      type: 'POST',
      url: `/ajax/generate-property-project-link`,
      data: _data,
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
      success: function (url) {
        window.location.href = url
      },
      dataType: 'json',
    })
  })

  // ------------------------------------------------------- //
  //   property and project show page navbar
  // ------------------------------------------------------- //

  if (($(window).width()) > 992) {
    $(window).scroll(function () {
      var scroll = $(this).scrollTop()
      if (scroll > 90) {
        $('.project-show .proj-stick-nav').addClass('sticky')
        $('.project-show header.header').hide()
      }
      else {
        $('.project-show .proj-stick-nav').removeClass('sticky')
        $('.project-show header.header').show()
      }
    })
  }

  // --------------
  //   side share
  // --------------

  $('.share-btn').on('click', function () {
    $('.side-share .share .share-container').slideToggle(400)
  })

  $('.close-btn').on('click', function () {
    $('.side-share .share .share-container').slideUp(400)
  })

  // show overLay when focus on input in the navbar 
  if (($(window).width()) > 992) {
    $('.navbar .form-control-sm').
      focus(function () {
        $('.background-overlay').show()
      })
    
    // Hide Background Overlay When Click outside navbar
    $(document).on('click', function (event) {
      var $trigger = $('.navbar.navbar-expand-lg')
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $('.background-overlay').hide()
      }
    })
  }

  // Hide menu When Click Outside
  $(document).on('click', function (event) {
    var $trigger = $('.side-share')
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
      $('.side-share .share .share-container').slideUp(400)
    }
  })

  // print button
  $('.print-detail').on('click', function () {
    window.print()
  })

  //To Hide Modal on Click Back Button
  //-----------
  $('.modal').on('shown.bs.modal', function () {
    var urlReplace = '#' + $(this).attr('id')
    history.pushState(null, null, urlReplace)
  })

  $(window).on('popstate', function () {
    $('.modal').modal('hide')
  })
  //-----------
})